import { render, staticRenderFns } from "./TeacherMasterclasses.vue?vue&type=template&id=cfba464e&"
import script from "./TeacherMasterclasses.vue?vue&type=script&lang=js&"
export * from "./TeacherMasterclasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports